import serverCode from '../../serverCode'

const defaultState = () => ({
  items: [],
  length: 0,
  paged: 0,
  tags: [],
})

const state = defaultState()

const getters = {}

const mutations = {
  incrementPage(state) {
    state.paged++
  },
  setItems(state, payload) {
    state.length = payload.length
    state.items = state.items.concat(payload)
  },
  setTags(state, tags) {
    state.tags = tags
  },
  resetItems(state) {
    Object.assign(state, defaultState())
  },
}

const actions = {
  async getItems({ state, commit, rootState }, { tagIds, sortBy, perPage }) {
    try {
      const { succeed, reportArticles, tags } = await serverCode(
        'getReportArticlesByTag',
        {
          tagIds,
          sortBy,
          offset: state.paged * perPage,
          perPage,
        },
        rootState.locale
      )
      if (!succeed) {
        throw new Error()
      } else {
        commit('setItems', reportArticles)
        commit('setTags', tags)
      }
    } catch (error) {
      //
    }
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
}
